import { render } from "./Searchbar.vue?vue&type=template&id=205eb054&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=205eb054&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205eb054"]])

export default __exports__